export default [
  "You have impeccable manners.",
  "I like your style.",
  'Is that your picture next to "charming" in the dictionary?',
  "Your kindness is a balm to all who encounter it.",
  "Your insides are even more beautiful than your outside.",
  "That thing you don't like about yourself is what makes you really interesting.",
  "You're inspiring.",
  "You're so thoughtful.",
  "You have a good head on your shoulders.",
  "You should be proud of yourself.",
  "You are making a difference.",
  "You deserve a hug right now.",
  "You're a great example to others.",
  "    Actions speak louder than words, and yours tell an incredible story.",
  "    I appreciate you.",
  "You are the most perfect you there is.",
  "You are enough.",
  "You're all that and a super-size bag of chips.",
  "On a scale from 1 to 10, you're an 11.",
  "You've got all the right moves.",
  "Everything would be better if more people were like you.",
  "When you're not afraid to be yourself, that's when you're incredible.",
  "You're wonderful.",
  "You're better than a triple-scoop ice cream cone. With sprinkles.",
  "You're one of a kind.",
  "If you were a box of crayons, you'd be the big industrial name-brand one with a built-in sharpener.",
  "Who raised you? They deserve a medal for a job well done.",
  "Somehow you make time stop and fly all at the same time.",
  'In high school, I bet you were voted "most likely to continue being awesome."',
  "If you were a scented candle they'd have to call it Perfectly Imperfect (and it would smell like summer).",
  "There's ordinary, and then there's you.",
  "You're even better than a unicorn because you're real.",
  "You're really something special."
];
